module.exports = __webpack_public_path__ + "static/media/ana_amarela.f63e93be.png";